import { createContext, useContext, useLayoutEffect } from 'react';

export const HeaderActionContext = createContext({
    mobileLeftAction: null,
    setMobileLeftAction: () => {},
});

export const useHeaderAction = () => useContext(HeaderActionContext);

export const useMobileHeaderBackAction = (onClick, enabled = true) => {
    const { setMobileLeftAction } = useHeaderAction();

    useLayoutEffect(() => {
        if (!enabled) return undefined;

        const backAction = {
            type: 'back',
            ariaLabel: 'Back',
            onClick,
        };

        setMobileLeftAction(backAction);

        return () => {
            setMobileLeftAction((currentAction) => (
                currentAction === backAction ? null : currentAction
            ));
        };
    }, [enabled, onClick, setMobileLeftAction]);
};
